import {
    get,
    put,
    patch,
    post,
    fetch,
    get2,
    put2
} from "../ApiDecorator";

const stuTest = {
    // pad端获取班级信息以及测评状态
    queryClassStatus(data) {
        return get('/learn/open/sync/student/query-class-status', data)
    },
    // pad端扫码后学生列表
    stuList(data) {
        return get('/learn/open/sync/student/query-students-by-id', data)
    },
    // pad端查询作品列表
    queryStuUploadList(data) {
        return get('/learn/open/sync/student/query-student-list', data)
    },
    // pad端上传作品
    uploadStuWork(data) {
        return post('/learn/open/sync/student/upload-student-work', data)
    },
    // pad端查询作品状态
    queryWork(data) {
        return get('/learn/open/sync/student/query-work', data)
    },
    // pad端提交作品
    addWork(data) {
        return put('/learn/open/sync/student/add-work', data)
    },
    // pad端学生端上课
    classIn(data) {
        return put2(`/learn/open/sync/student/student-class-in`, data)
    },
    // pad端学生端下课
    classOut(data) {
        return put2('/learn/open/sync/student/student-class-out', data)
    },
    // pad端查询教师上下课状态
    checkStatus(data) {
        return get('/learn/open/sync/student/class-test-status', data)
    },
    // 教师端班级报告-整体情况
    overallSituation(data) {
        return get('/learn/teaWordTest/overall-situation', data)
    },
    // 教师端班级报告-本班单项平均成绩
    levelStuNumGroup(data) {
        return get('/learn/teaWordTest/levelStuNumGroup', data)
    },
    // 教师端班级报告-本班学生测评列表
    levelStuList(data) {
        return get('/learn/teaWordTest/levelStuList', data)
    },
    // 教师端班级报告-班级历史成绩对比(四象限图)
    getClassStuAllTypeScoreList(data) {
        return get('/learn/teaWordTest/getClassStuAllTypeScoreList', data)
    },
    // 教师端班级报告-本班单项平均成绩 
    getAvgScoreStu(data) {
        return get('/learn/teaWordTest/getAvgScoreStu', data)
    },
    // 教师端班级报告-综合评价四看
    comprehensiveEval(data) {
        return get('/learn/teaWordTest/comprehensiveEval', data)
    },
    // 教师端-重新测评
    resetTest(data) {
        return put2('/learn/sync/teacher/class-test-stop', data)
    },
    // 教师端-重新获取档期测评次序
    getEvalNum(data) {
        return get('/learn/sync/teacher/open/query-class-test-eval-num', data)
    },
    // 教师端-给学生单独下课
    offlineStudent(data) {
        return put2('/learn/sync/teacher/stop-stu', data)
    }
}

export default stuTest;